import { createLifeGrid } from '../core/cells';

export const glider = createLifeGrid({ 
  "0,0": true,
  "1,0": true,
  "2,0": true,
  "2,1": true,
  "1,2": true,
});

export const lwss = createLifeGrid({
  "1,0": true,
  "4,0": true,
  "0,1": true,
  "0,2": true,
  "4,2": true,
  "0,3": true,
  "1,3": true,
  "2,3": true,
  "3,3": true
});